/*参观服务-子路由*/
export default [
  {
    path: "/service/cgyy", //已结
    name: "service_cgyy",
    component: resolve =>
      require(["@/components/service/cgyy/index.vue"], resolve),
    meta: {
      title: "参观预约"
    },
  },
  {
    path: "/service/jiangjie", //已结
    name: "jiangjie",
    component: resolve =>
      require(["@/components/service/cgyy/jiangjie.vue"], resolve),
    meta: {
      title: "讲解时间"
    },
  },
  {
    path: "/service/contact", //已结
    name: "jiangjie",
    component: resolve =>
      require(["@/components/service/cgyy/contact.vue"], resolve),
    meta: {
      title: "联系我们"
    },
  },
  
  {
    path: "/service/lyb",
    name: "service_lyb",
    redirect: "/service/lyb/lyb", //已结
    component: resolve =>
      require(["@/components/service/lyb/index.vue"], resolve),
    meta: {
      title: "意见反馈"
    },
    children: [
      {
        path: "/service/lyb/lyb", //已结
        name: "service_lyb_lyb",
        component: resolve =>
          require(["@/components/service/lyb/lyb.vue"], resolve),
        meta: {
          title: "意见反馈",
          needLogin: false
        }
      },
    ]
  },
  {
    path: "/service/feedback",
    name: "service_feedback",
    redirect: "/service/feedback/feedback",
     component: resolve =>
      require(["@/components/service/feedback/index.vue"], resolve),
    meta: {
      title: "调查问卷"
    },
    children: [
      {
        path: "/service/feedback/feedback",
        name: "service_feedback_feedback",
        component: resolve =>
          require(["@/components/service/feedback/feedback.vue"], resolve),
        meta: {
          title: "调查问卷"
        }
      },
      {
        path: "/service/feedback/question/",
        name: "service_feedback_question",
        component: resolve =>
          require(["@/components/service/feedback/question.vue"], resolve),
        meta: {
          title: "问卷调查"
        }
      },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/service/index.js